import { Skeleton } from '../../Generic';
import { FiltersGrid } from '../styles';

const LoadingComponent = () => (
  <FiltersGrid>
    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>

    <div>
      <Skeleton
        style={{
          height: 20,
          width: 80,
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <Skeleton
        style={{
          height: 40,
          width: '100%',
          borderRadius: 8,
        }}
      />
    </div>
  </FiltersGrid>
);

export default LoadingComponent;
